import type { FeatureInitResponse } from '../types';

export const FeatureInitApi = Symbol.for('FeatureInitApi');

/**
 * Feature Init API
 * 获取用户的功能权限和配额信息
 */
export interface FeatureInitApi {
    /**
     * 获取功能初始化数据
     * @returns 功能权限和用户套餐信息
     */
    getFeatureInit(): Promise<FeatureInitResponse>;
}
